import { useCookieConsent } from "@/components/hooks/useCookieConsent";
import { useEffect, useRef } from "react";

export default function CookieConsent() {
  const { showPopup, acceptCookies, declineCookies } = useCookieConsent();
  const agreeBtnRef = useRef(null);

  useEffect(() => {
    if (showPopup) {
      agreeBtnRef.current?.focus();
    }
  }, [showPopup]);

  if (!showPopup) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 bg-white p-6 rounded-lg shadow-lg max-w-md mx-auto z-50">
      <p className="mb-4 text-sm">
        We use cookies to improve your experience. By clicking <strong>Agree</strong>, you
        consent to our{" "}
        <a href={`${process.env.NEXT_PUBLIC_SITE_URL}/cookie-policy`} className="text-blue-500 underline">
          cookie policy
        </a>.
      </p>
      <div className="flex justify-center space-x-4">
        <button
          ref={agreeBtnRef}
          onClick={acceptCookies}
          className="bg-gray-300  bg-blue text-black px-4 py-2 rounded hover:bg-blue-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600"
        >
          Agree
        </button>
        <button
          onClick={declineCookies}
          className="text-gray-800 px-4 py-2 rounded hover:bg-gray-400"
        >
          Decline
        </button>
      </div>
    </div>
  );
}